import { getDeviceOs, getDeviceType } from '@/composables/helpers/useDeviceType';

import { getDetectedGeoForTracking } from '@/composables/helpers/useDetectedGeo';
/* eslint-disable import/no-cycle */
import useApiHelpers from '@/composables/api/helpers';
import { useBuyOrderFormStore } from '@/stores/forms/buyOrderFormStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import { useSellOrderFormStore } from '@/stores/forms/sellOrderFormStore';

const getOrderMode = () => {
  try {
    const raw = localStorage.getItem('mode');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const getMerchApiOrderData = () => {
  const merch = useOrderFormStore().merchApiOrderData;
  if (!merch || typeof merch !== 'object' || Object.keys(merch).length === 0) {
    return {};
  }
  return {
    fiatAmount: merch.fiatAmount,
    fiatType: merch.fiatType,
    coinAmount: merch.coinAmount,
    coinType: merch.coinType,
    paymentMethod: merch.payment ?? merch.paymentMethod ?? merch.paymentType,
  };
};

export const getOrderData = () => {
  const mode = getOrderMode()?.toLowerCase();
  let orderData = {};
  if (mode) {
    switch (mode) {
      case 'buy': {
        const { getTrackingInformation } = useBuyOrderFormStore();
        orderData = { ...getTrackingInformation };
        break;
      }
      case 'sell': {
        const { getTrackingInformation } = useSellOrderFormStore();
        orderData = { ...getTrackingInformation };
        break;
      }
      default:
        break;
    }
  }

  if (orderData && Object.keys(orderData).length > 0) {
    return orderData;
  }

  return getMerchApiOrderData();
};

export default function useTracker() {
  const sendTrackerEvent = async (event = {}) => {
    const { postRequest } = useApiHelpers();
    const {
      host, pathname, referrer, search,
    } = window.location;

    const utmSource = new URLSearchParams(search).get('utm_source');
    const geo = getDetectedGeoForTracking();

    const defaultData = {
      page: {
        host,
        pathname,
        referrer,
        ...(utmSource ? { utmSource } : {}),
      },
      order: {
        ...getOrderData(),
      },
      client: {
        ...(geo ? { geo } : {}),
        locale: navigator.language || null,
        device: getDeviceType(),
        os: getDeviceOs(),
        userAgent: navigator.userAgent || null,
      },
    };

    const {
      type = 'FRONTEND_ORDER_JOURNEY',
      subtype = 'PAGE_VISIT',
      data,
    } = event;

    try {
      const response = await postRequest('/track', {
        data: {
          ...defaultData,
          ...data,
        },
        event_type: type,
        event_sub_type: subtype,
      });
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  return {
    sendTrackerEvent,
  };
}

export const sendConversionTrackEvent = (eventName, payload = {}) => {
  const { sendTrackerEvent } = useTracker();
  sendTrackerEvent({
    type: 'FRONTEND_ORDER_JOURNEY',
    subtype: eventName,
    data: payload,
  }).catch(() => {
    // fail silent — tracking must not affect checkout
  });
};
